/**
 *	city-district-select.conf.js
 */
 
import angular from 'angular';
import cityDistrictSelectDirective from './city-district-select.directive.js';
import CityDistrictSelectServ from './city-district-select.serv.js';

export default angular.module('cityDistrictSelect', [])
	.directive('cityDistrictSelect', cityDistrictSelectDirective)
	.service('cityDistrictSelectServ', CityDistrictSelectServ)
	.name;